// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"74b9f636","765":"f891e7ff","787":"eb984050"}[chunkId] + ".chunk.js";
};